import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { AppLanguageService } from '../services/app-language.service'

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
    constructor(private appLanguageService: AppLanguageService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const language = this.appLanguageService.getAppLanguage()
        const headers = req.headers.set('Accept-Language', language)
        const modifiedReq = req.clone({ headers })
        return next.handle(modifiedReq)
    }
}
